import { styled } from '../../utils/core.styled'

export const Input = styled('input')({
    display: 'none',
})
